<template>
    <!--
        FASE 4 / BLOCO AB — DOC 33: consulta externa por link.

        Fora do layout autenticado de propósito: quem recebe o link não tem conta no sistema.
        Mostra apenas metadados — o conteúdo não é servido por aqui.
    -->
    <div class="pagina-publica">
        <div class="cartao">
            <div v-if="carregando" class="u-text-center">
                <img src="/public/img/loading-bar.gif" />
            </div>

            <template v-else-if="doc">
                <h2>{{ doc.titulo }}</h2>
                <p v-if="doc.descricao" class="descricao">{{ doc.descricao }}</p>

                <table class="dados">
                    <tr><th>Criado em</th><td>{{ doc.created_at | formatarData }}</td></tr>
                    <tr><th>Visibilidade</th>
                        <td>{{ doc.publico ? 'Público' : 'Privado' }}</td></tr>
                </table>

                <div class="aviso">
                    <i class="el-icon-info"></i>
                    Este link confirma a existência e a identificação do documento.
                    Para obter o arquivo, entre em contato com a instituição que o compartilhou.
                </div>
            </template>

            <div v-else class="erro">
                <i class="el-icon-warning-outline"></i>
                <p>{{ mensagemErro }}</p>
            </div>
        </div>
    </div>
</template>
<script>

import moment from 'moment'

export default {
    filters: {
        formatarData (v) { return v ? moment(v).format('DD/MM/YYYY HH:mm') : '—' }
    },
    data: () => ({
        carregando: true,
        doc: null,
        mensagemErro: 'Link inválido, revogado ou expirado.'
    }),
    mounted () {
        const token = this.$route.params.token

        // Sem cabeçalho de autenticação: a rota é pública por definição.
        this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/publico/documento/link/${token}`)
            .then(r => { this.doc = r.data; this.carregando = false })
            .catch(e => {
                const d = e && e.response ? e.response.data : null
                if (d && typeof d.erro === 'string') this.mensagemErro = d.erro
                this.carregando = false
            })
    }
}
</script>
<style scoped>
.pagina-publica { min-height: 100vh; background: #F5F7FA; padding: 40px 15px; }
.cartao { max-width: 620px; margin: 0 auto; background: #fff; border-radius: 6px;
          box-shadow: 0 2px 12px rgba(0,0,0,.08); padding: 28px; }
h2 { margin: 0 0 10px; font-size: 20px; color: #303133; }
.descricao { color: #606266; }
.dados { width: 100%; margin-top: 18px; }
.dados th { text-align: left; width: 140px; color: #909399; font-weight: 500; padding: 5px 0; }
.dados td { padding: 5px 0; }
.aviso { margin-top: 22px; padding: 12px; background: #F4F4F5; border-radius: 4px;
         font-size: 13px; color: #606266; }
.erro { text-align: center; color: #F56C6C; padding: 30px 0; }
.erro i { font-size: 42px; display: block; margin-bottom: 12px; }
</style>
